export class Validation
{
	constructor()
	{
	}

	static Patterns = {
		Quantity: /^[1-9][0-9]*$/,
		Email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		Url: /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.?[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/
	};

	static Email(email: string): boolean
	{
		let matchArray = null;
		let isValid = true;

		if (email !== null && email !== undefined)
		{
			email = email.replace("name@emailaddress.com", "");
			email = email.replace(" ", "");
			matchArray = email.match(Validation.Patterns.Email);

			if (matchArray === null || email === "")
			{
				isValid = false;
			}
		}

		return isValid;
	}

	static Quantity(quantity: string): boolean
	{
		const matchArray = quantity.match(Validation.Patterns.Quantity);
		let isValid = true;

		if (matchArray === null || quantity === "")
		{
			isValid = false;
		}

		return isValid;
	}

	static SiteSearch(searchString: string): boolean
	{
		let critiera = searchString;

		critiera = critiera.replace("<", "&lt;").replace(">", "&gt;").replace("'", "&rsquo;").replace("\"\"", "&#x22;").replace(")", "&#x29;").replace("(", "&#x28;").replace("src=", "");

		if (critiera !== null && critiera !== undefined && critiera !== "")
		{
			return true;
		}
		else
		{
			return false;
		}
	}
}